import React, { useEffect, useState } from 'react';
import {
	BookingWizardTab,
	SidebarStatus,
	VisibilityStatus,
} from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizard';
import If from 'Views/Components/If/If';
import { Button, Colors, Display, Sizes } from 'Views/Components/Button/Button';
import classnames from 'classnames';
import { FerryBookingTimerWrap } from '../Components/FerryBookingTimerWrap';

interface FerryBackButtonProps {
	onClick?: () => void;
	isIpad: boolean;
	tabs: BookingWizardTab[];
	currentTabIndex: number;
	onTimerExpiry: () => void;
	ticketsPageUrl: string;
	forEventBooking: boolean;
	isDisabled?: boolean;
}

export function FerryBackButton({
	onClick,
	isIpad,
	tabs,
	currentTabIndex,
	onTimerExpiry,
	ticketsPageUrl,
	forEventBooking,
	isDisabled,
}: FerryBackButtonProps) {
	const [stepWithNoSidebar, setStepWithNoSidebar] = useState(
		tabs[currentTabIndex].sidebarStatus === SidebarStatus.NO_SIDEBAR,
	);

	// We may have had to omit some tabs, so we can't directly check that our current index is 0
	const firstStep: boolean = tabs.findIndex(tab => tab.visibility !== VisibilityStatus.EXCLUDED) === currentTabIndex;

	const { sidebarStatus } = tabs[currentTabIndex];

	useEffect(() => {
		setStepWithNoSidebar(sidebarStatus === SidebarStatus.NO_SIDEBAR);
	}, [sidebarStatus]);

	let buttonText = 'Back';
	if (firstStep) {
		buttonText = '';
	}

	return (
		<If condition={(!firstStep && isIpad) || !isIpad}>
			<div className={classnames('booking-wizard-back-btn', { 'no-sidebar': stepWithNoSidebar })}>
				{/*
					The countdown renders inside a black Button so it reads as part of the bottom bar
					rather than a card sitting on it. Its `pill` variant is written not to emit a
					<button> of its own — a button inside a button is invalid and swallows the click.
				*/}
				<If condition={!isIpad}>
					<Button display={Display.Solid} sizes={Sizes.Large} colors={Colors.Black}>
						<FerryBookingTimerWrap
							onTimerExpiry={onTimerExpiry}
							isIpad={isIpad}
							ticketsPageUrl={ticketsPageUrl}
							forEventBooking={forEventBooking}
						/>
					</Button>
				</If>
				<Button
					className={classnames(' back-btn', {
						'no-sidebar': stepWithNoSidebar,
						'hide-back-button': firstStep,
					})}
					display={Display.Solid}
					sizes={Sizes.Large}
					colors={Colors.Black}
					onClick={onClick}
					disabled={isDisabled}
				>
					{buttonText}
				</Button>
			</div>
		</If>
	);
}
